import Footer from "@/components/landing-page/Footer";
import { routesURL } from "@/components/urls";
import { millisecondsToDate2 } from "@/components/utility";
import Link from "next/link";
import React from "react";

const BlogCard = (props) => {
  return (
    <Link href={props.link}>
      <div className=" grid grid-cols-[2.5fr,3fr] max-md:grid-cols-1  gap-x-20 hover:cursor-pointer hover:shadow-lg py-6 px-6 max-md:px-0 rounded-lg">
        <div className="h-[210px]">
          <img
            src={props.cover}
            alt={props.summary}
            className=" w-full h-full"
          />
        </div>
        <div className=" max-md:mt-6">
          <div className=" flex items-center">
            <div className=" py-1 px-6 bg-black text-[13px] rounded-lg text-white capitalize">
              {props.category}
            </div>
          </div>
          <div className=" text-[13px] mt-3 font-medium text-neutral-500 antialiased">
            {props.date}
          </div>
          <div className=" mt-3 text-[30px] antialiased font-semibold text-black">
            {props.title}
          </div>
          <div className=" mt-1 text-[16px] font-medium antialiased">
            {props.summary}
          </div>
        </div>
      </div>
    </Link>
  );
};
const Blog = () => {
  const data = [
    {
      cover: "/images/guides/start-guide-cover.png",
      title: "Hot to start guide",
      date: millisecondsToDate2(Date.now()),
      summary: "The best ways to start with flamingos guides",
      category: "guides",
      link: `${routesURL.blogArticle.dynamic(
        "guides",
        "how-to-get-started-with-flamingos"
      )}`,
    },
    {
      cover: "/images/guides/start-guide-cover.png",
      title: "Hot to start guide",
      date: millisecondsToDate2(Date.now()),
      summary: "The best ways to start with flamingos guides",
      category: "guides",
      link: `${routesURL.blogArticle.dynamic(
        "guides",
        "how-to-get-started-with-flamingos"
      )}`,
    },
    {
      cover: "/images/guides/start-guide-cover.png",
      title: "Hot to start guide",
      date: millisecondsToDate2(Date.now()),
      summary: "The best ways to start with flamingos guides",
      category: "guides",
      link: `${routesURL.blogArticle.dynamic(
        "guides",
        "how-to-get-started-with-flamingos"
      )}`,
    },
    {
      cover: "/images/guides/start-guide-cover.png",
      title: "Hot to start guide",
      date: millisecondsToDate2(Date.now()),
      summary: "The best ways to start with flamingos guides",
      category: "guides",
      link: `${routesURL.blogArticle.dynamic(
        "guides",
        "how-to-get-started-with-flamingos"
      )}`,
    },
  ];
  return (
    <>
      <main className=" min-h-[calc(100vh-58px] p-10 max-md:p-4">
        <section className=" pt-[4rem] max-md:pt-[1rem]">
          <h1 className=" text-center text-[38px] max-md:text-[28px] text-black font-bold">
            Explore our blogs
          </h1>
          {/* Blog cards container */}
          <div className=" mt-[2rem] flex flex-col gap-y-10 items-center max-w-[1100px] mx-auto">
            {data.map((item, indx) => (
              <BlogCard {...item} key={indx} />
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Blog;
